

import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IProcedureFee } from 'src/app/models/IProcedureFee';
import { ToastrService } from 'ngx-toastr';
import { ProcedureFeeService } from 'src/app/Services/ProcedureFee/procedure-fee.service';
import { ICptOrdersComponent } from 'src/app/models/ICptOrdersComponent';
import { MatTableDataSource, MatPaginator } from '@angular/material';

export interface ClaimType {
  value: number;
  viewValue: string;
}

@Component({
  selector: 'app-generalfee',
  templateUrl: './generalfee.component.html',
  styleUrls: ['./generalfee.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],


})
export class GeneralfeeComponent implements OnInit {
  columnsToDisplay = ['cptCode', 'description', 'price', 'medicare', 'wcPrice', 'selfPrice', 'oon', 'Action'];
  headercolumnsToDisplay = ['CPT Code', 'Description', 'Price', 'Medicare', 'WC', 'Self Pay', 'OON', 'Action'];
  expandedElement: any | null;
  procedureFeeDetails: IProcedureFee;
  public result: any;
  cptCodeLst: ICptOrdersComponent[] = [];
  medicareVal: any = 0;
  wcVal: any = 0;
  selfPayVal: any = 0;
  oonVal: any = 0;
  allProcedureFees: IProcedureFee[] = [];
  public updatedList: IProcedureFee[];
  public NDCMangeList: IProcedureFee[];
  public existUpdatedList: IProcedureFee[];
  calcModifier: string;
  public procedureObj: IProcedureFee;
  procedureDataSourse = new MatTableDataSource(this.allProcedureFees);
  public show: boolean = false;

  public splitModifier;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  // @ViewChild("price") nameField:ElementRef;
  showInfo() {


    this.procedureFeeForm.reset();
    this.procedureFeeForm.markAllAsTouched();
    this.procedureFeeForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.procedureFeeForm);
    });
    this.medicareVal = 0;
    this.wcVal = 0;
    this.selfPayVal = 0;
    this.oonVal = 0;

    this.show = !this.show;
    this.expandedElement = null;

  }


  claimTypeLst: ClaimType[] = [
    { value: 1, viewValue: 'PROFESSIONAL' },
    { value: 2, viewValue: 'INSTITUTIONAL' },

  ];

  procedureFeeForm: FormGroup;
  submitted = false;
  constructor(private formBuilder: FormBuilder, private procedureFeeService: ProcedureFeeService,
    private toastr: ToastrService) { }

  formErrors = {
    'cptCode': '',
    'price': '',
    'type': '',
  };
  validationMessages = {

    'cptCode': {
      'required': 'CPTCode is required.'
    },
    'price': {
      'required': 'Price is required.'
    },
    'type': {
      'required': 'Type is required.'
    },
  };

  ngOnInit() {
    this.procedureFeeForm = this.formBuilder.group({
      // ProcedureName: ['', Validators.required],
      cptCode: ['', Validators.required],
      price: ['', Validators.required],
      type: ['', Validators.required],
      modifier1: [''],
      modifier2: [''],
      modifier3: [''],
      modifier4: [''],
      medicare: [''],
      wcPrice: [''],
      selfPrice: [''],
      oon: [''],
      description: [''],

    });
    this.procedureDataSourse.paginator = this.paginator;
    this.bindCPTCodesOnDropdown();
    this.getProcedureFee();
  }

  get f() { return this.procedureFeeForm.controls; }

  bindCPTCodesOnDropdown() {
    this.procedureFeeService.getCPTCodes().subscribe((data: ICptOrdersComponent[]) => {
      this.cptCodeLst = data;
    })
  }
  onKeyPress(event: any) {
    const priceValue = event.target.value;
    var medV = this.procedureFeeForm.value.medicare;
    var WCv = this.procedureFeeForm.value.wcPrice;
    var selfV = this.procedureFeeForm.value.selfPrice;
    var oonV = this.procedureFeeForm.value.oon;
    if (priceValue == null || priceValue == '') {
      this.procedureFeeForm.controls['medicare'].setValue('');
      this.procedureFeeForm.controls['wcPrice'].setValue('');
      this.procedureFeeForm.controls['selfPrice'].setValue('');
      this.procedureFeeForm.controls['oon'].setValue('');
    }
    if (medV != "" || WCv != "" || selfV != "" || oonV != "") {
      this.medicareVal = (priceValue * (this.procedureFeeForm.value.medicare / 100)).toString();
      this.wcVal = (priceValue * (this.procedureFeeForm.value.wcPrice / 100)).toString();
      this.selfPayVal = (priceValue * (this.procedureFeeForm.value.selfPrice / 100)).toString();
      this.oonVal = (priceValue * (this.procedureFeeForm.value.oon / 100)).toString();
    } else {
      this.medicareVal = ''; this.wcVal = ''; this.selfPayVal = ''; this.oonVal = '';
    }
  }

  OnSelectionChange(event, CntrlName) {
    var enterPrice = this.procedureFeeForm.get('price').value;
    if (enterPrice == "" || enterPrice == 0 || enterPrice == null) {
      this.toastr.error('Please Enter Price');

      if (CntrlName == 'medicare') {
        this.procedureFeeForm.controls['medicare'].setValue('');
      }
      if (CntrlName == 'wcPrice') {
        this.procedureFeeForm.controls['wcPrice'].setValue('');
      }
      if (CntrlName == 'selfPrice') {
        this.procedureFeeForm.controls['selfPrice'].setValue('');
      }
      if (CntrlName == 'oon') {
        this.procedureFeeForm.controls['oon'].setValue('');
      }

      //return;

    } else {
      if (CntrlName == 'medicare') {
        let medP = event.value;
        this.medicareVal = (enterPrice * (medP / 100)).toString();
      }
      if (CntrlName == 'wcPrice') {
        let wcP = event.value;
        this.wcVal = (enterPrice * (wcP / 100)).toString();
      }
      if (CntrlName == 'selfPrice') {
        let selfP = event.value;
        this.selfPayVal = (enterPrice * (selfP / 100)).toString();
      }
      if (CntrlName == 'oon') {
        let oonP = event.value;
        this.oonVal = (enterPrice * (oonP / 100)).toString();
      }
    }



  }
  saveProcedureFee() {
    if (this.procedureFeeForm.invalid) {
      return;
    }
    var objProcFeedetails: IProcedureFee = this.procedureFeeForm.value;
    this.calcModifier = objProcFeedetails.modifier1 + ',' + objProcFeedetails.modifier2 + ',' +
      objProcFeedetails.modifier3 + ',' + objProcFeedetails.modifier4;
    objProcFeedetails.medicarePercentage = this.medicareVal;
    objProcFeedetails.wcPercentage = this.wcVal;
    objProcFeedetails.selfPayPercentage = this.selfPayVal;
    objProcFeedetails.oonPercentage = this.oonVal;
    objProcFeedetails.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    objProcFeedetails.modifier = this.calcModifier;


    var claimTypeFilter = this.allProcedureFees.filter(c => c.type == this.procedureFeeForm.value.type && c.cptCode == this.procedureFeeForm.value.cptCode);
    if (claimTypeFilter.length > 0) {
      this.toastr.warning('Your Selected  Procedure Code ' + this.procedureFeeForm.value.cptCode + ' and  ClaimType ' + this.procedureFeeForm.value.type + ' Already Saved in Database. ');
      return;
    } else {
      this.procedureFeeService.saveProcedureFeeInfo(objProcFeedetails).subscribe(data => {
        this.result = data;
        this.getProcedureFee();
        this.toastr.success('Successfully Saved..');
        this.clearGeneralfeeDetails();
      })
      this.show = false;
      this.expandedElement = null;
    }
  }
  onCellClick(element: IProcedureFee) {
    this.show = false;
    this.procedureFeeForm.markAllAsTouched();
    this.procedureFeeForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.procedureFeeForm);
    });
    this.splitModifier = element.modifier.split(',');
    var bindModifier1 = this.splitModifier[0];
    var bindModifier2 = this.splitModifier[1];
    var bindModifier3 = this.splitModifier[2];
    var bindModifier4 = this.splitModifier[3];
    if (bindModifier1 == "null") {
      bindModifier1 = ''
    } else {
      this.splitModifier[0];
    }
    if (bindModifier2 == "null") {
      bindModifier2 = ''
    } else {
      this.splitModifier[1];
    }
    if (bindModifier3 == "null") {
      bindModifier3 = ''
    } else {
      this.splitModifier[2];
    }
    if (bindModifier4 == "null") {
      bindModifier4 = ''
    } else {
      this.splitModifier[3];
    }
    this.procedureFeeForm.patchValue({
      cptCode: element.cptCode,
      price: element.price,
      medicare: element.medicare,
      wcPrice: element.wcPrice,
      selfPrice: element.selfPrice,
      oon: element.oon,
      type: element.type,
      description: element.description,
      modifier1: bindModifier1,
      modifier2: bindModifier2,
      modifier3: bindModifier3,
      modifier4: bindModifier4,
    });
    this.medicareVal = element.medicarePercentage;
    this.wcVal = element.wcPercentage;
    this.selfPayVal = element.selfPayPercentage;
    this.oonVal = element.oonPercentage;
  }
  upDateProcedure(element: IProcedureFee) {
    if (this.procedureFeeForm.invalid) {
      return;
    }
    this.updatedList = this.allProcedureFees.filter(x => x.procedureFeeId !== element.procedureFeeId);
    var claimTpye = this.procedureFeeForm.value.type;
    var cptCode = this.procedureFeeForm.value.cptCode;
    this.existUpdatedList = this.updatedList.filter(x => x.type === claimTpye && x.cptCode === cptCode);
    if (this.existUpdatedList.length > 0) {
      this.toastr.warning("This ManagerFee Details Already Exist");
      return;
    }
    this.procedureFeeDetails = this.procedureFeeForm.value;
    this.calcModifier = this.procedureFeeDetails.modifier1 + ',' + this.procedureFeeDetails.modifier2 + ',' +
      this.procedureFeeDetails.modifier3 + ',' + this.procedureFeeDetails.modifier4;
    this.procedureFeeDetails.modifier = this.calcModifier;
    this.procedureFeeDetails.medicarePercentage = this.medicareVal;
    this.procedureFeeDetails.wcPercentage = this.wcVal;
    this.procedureFeeDetails.selfPayPercentage = this.selfPayVal;
    this.procedureFeeDetails.oonPercentage = this.oonVal;
    this.procedureFeeDetails.modifiedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.procedureFeeDetails.procedureFeeId = element.procedureFeeId;

    this.procedureFeeService.saveProcedureFeeInfo(this.procedureFeeDetails).subscribe(data => {
      this.result = data;
      this.toastr.success(" Updated Successfully.");
      this.getProcedureFee();
      this.expandedElement = null;
    })
  }
  getProcedureFee() {

    this.procedureFeeService.getProcedureFee().subscribe(
      data => {
        this.allProcedureFees = data;
        this.procedureDataSourse.data = this.allProcedureFees;
      }, (err: any) => console.log(err));
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  clearUpdatedProcedure() {
    this.procedureFeeForm.reset();
    this.medicareVal = '';
    this.wcVal = '';
    this.selfPayVal = '';
    this.oonVal = '';
  }
  cancelProcedureFee() {
    this.procedureFeeForm.reset();
    this.medicareVal = '';
    this.wcVal = '';
    this.selfPayVal = '';
    this.oonVal = '';
  }
  clearGeneralfeeDetails() {
    this.procedureFeeForm.patchValue({
      cptCode: '',
      price: '',
      type: '',
      modifier1: '',
      modifier2: '',
      modifier3: '',
      modifier4: '',
      medicare: '',
      wcPrice: '',
      selfPrice: '',
      oon: '',
      description: '',
    });
  }


  logValidationErrors(group: FormGroup = this.procedureFeeForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  DisableAllFormControls(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.DisableAllFormControls(abstractControl);
      } else {
        abstractControl.disable();
      }
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.procedureDataSourse.filter = filterValue;
  }
}


